import { ReactNode } from 'react';

import {
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Typography,
  TypographyProps,
  createStyles,
  makeStyles,
} from '@material-ui/core';

import { RiCloseLine as CloseIcon } from '@remixicon/react';

const useHeaderStyles = makeStyles(theme =>
  createStyles({
    root: {
      margin: 0,
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.text.disabled,
    },
    headerContent: {
      paddingTop: 0,
      overflow: 'visible',
    },
  }),
);

export const DialogHeader = ({
  title,
  titleProps,
  subTitle,
  subTitleProps,
  onClose,
  disabled,
}: {
  title: ReactNode;
  titleProps?: TypographyProps;
  subTitle?: ReactNode;
  subTitleProps?: TypographyProps;
  onClose?: () => void;
  disabled?: boolean;
}) => {
  const classes = useHeaderStyles();

  return (
    <>
      <DialogTitle disableTypography className={classes.root}>
        <Typography variant="h4" {...titleProps}>
          {title}
        </Typography>
        {onClose ? (
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
            disabled={disabled}
           data-track-source-anchor="6a5165f12a;;low">
            <CloseIcon />
          </IconButton>
        ) : null}
      </DialogTitle>
      {!!subTitle && (
        <DialogContent className={classes.headerContent}>
          <DialogContentText variant="body2" {...subTitleProps}>
            {subTitle}
          </DialogContentText>
        </DialogContent>
      )}
    </>
  );
};
